import { useRef } from 'react'
import {
  Body,
  Footer,
  FooterAction,
  Header,
  HeaderClose,
  HeaderTitle,
  Outer,
  Overlay,
} from './modal-panel.styled'
import useModal from 'modules/modal/state/use-modal'
import { UiIcon } from 'modules/ui/atoms/Icon'

export interface ModalPanelProps {
  title?: string
  children: React.ReactNode
  closeButtonDataId?: string
}

const ModalPanel = ({ title, children, closeButtonDataId = '' }: ModalPanelProps) => {
  const modal = useModal()
  const closeButtonRef = useRef<HTMLButtonElement>(null)

  return (
    <Overlay isOpen={!!modal.current}>
      <Outer>
        <Header>
          {title && <HeaderTitle>{title}</HeaderTitle>}
          <HeaderClose ref={closeButtonRef} onClick={modal.close} data-id={closeButtonDataId}>
            <UiIcon name="close" />
          </HeaderClose>
        </Header>
        {children}
      </Outer>
    </Overlay>
  )
}

ModalPanel.Body = Body
ModalPanel.Footer = Footer
ModalPanel.FooterAction = FooterAction

export default ModalPanel
